export default function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-selection/src/selection/datum.js
// module id = ../../../../d3-selection/src/selection/datum.js
// module chunks = 4